angular.module('jv.Dashboard.ActionsMenu.Controller', [
    'jv.choose.add.reqs.form.directive'
])
.controller('jv.Dashboard.ActionsMenu.Controller', [
    '$scope',
    'jvContextualLoadingService',
    '$window',
    function($scope, jvContextualLoadingService, $window) {
    var widgetObject = $scope.widgetObject;
    jvContextualLoadingService.hide($scope.widgetObject.widgetId);
    var widgetSettings = widgetObject.userWidgetSettings.widgetSetting;
    $scope.links = [];

    for (var i = 0; i < widgetSettings.length; i++) {
        var linksObject = {};
        var widgetSettingsObject = widgetSettings[i].subWidgetSettings;
        if (!widgetSettingsObject) {
            continue;
        }
        angular.forEach(widgetSettingsObject, function(widgetSettingObject, index) {
            switch(widgetSettingObject.settings.name) {
                case "Name":
                    linksObject.name =  widgetSettingObject.settings.defaultValues[0].label;
                    linksObject.key = widgetSettingObject.settings.defaultValues[0].name;
                    break;
                case "Url":
                    linksObject.url =  widgetSettingObject.settings.defaultValues[0].value;
                    break;
                case "IconFont":
                    linksObject.iconFontClass = widgetSettingObject.settings.defaultValues[0].value;
                    break;
            }
        });
        $scope.links.push(linksObject);
    };

    $scope.handleLinkClick = function (link) {
        if (link.key === 'DASHBOARD.WIDGET.LINKS.ADD_REQUISITION') {
            $scope.showChooseReqsFormModal = true;
            $scope.addRequisitionsUrl = link.url;
            return;
        }
    };

    $scope.getHrefValue = function (link) {
        if (link.key === 'DASHBOARD.WIDGET.LINKS.ADD_REQUISITION') {
            return '';
        }
        return link.url;
    };

    $scope.closeAddRequisition = function () {
        $scope.showChooseReqsFormModal = false;
    };
}]);
